(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("myAccount", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/account/myAccountView.html",
            controller: ["accountsResource", "myAccountResource", "authService", "CONST_ALLROLES", "USER_ROLES", "$rootScope", "$scope", "$state", "_", "messageService", "$uibModal", "DTOptionsBuilder", "DTColumnDefBuilder", "$translate", "globalizationService", "frameworkService", MyAccountCtrl],
            controllerAs: "vm"
        };
        function MyAccountCtrl(accountsResource, myAccountResource, authService, CONST_ALLROLES, USER_ROLES, $rootScope, $scope, $state, _, messageService, $uibModal, DTOptionsBuilder, DTColumnDefBuilder, $translate, globalizationService, frameworkService) {
            var vm = this;
            vm.lang = $translate.proposedLanguage() || $translate.use();
            vm.historyOpen = false;
            vm.profileRecord = {};
            vm.accountDetailsLoaded = false;
            vm.enabledLocalizations = frameworkService.data.tenant.enabledLocalizations;
            vm.tenant = frameworkService.data.tenant;
            vm.aboutMeHasEditableFields = vm.tenant.userCanChangeName ||
                vm.tenant.userCanChangeUsername ||
                vm.tenant.userCanChangeEmail ||
                vm.tenant.userCanChangePassword ||
                vm.enabledLocalizations.length > 1;
            vm.frameworkData = frameworkService.data;
            //vm.isPhone = (jQuery as any).browser.mobile;
            //vm.isLearner = authService.authentication.isLearner;
            vm.authService = authService;
            vm.userRoles = [];
            vm.processModificationNotes = function () {
                if (vm.profileRecord.userModificationNotes) {
                    vm.profileRecord.userModificationNotes.forEach(function (item) {
                        var values = "";
                        if (item.modificationValues !== "") {
                            values = JSON.parse(item.modificationValues);
                            //In the case where a group has been removed from the DB,
                            //the server returns common.notFound instead of the group name
                            //so that has to be translated separately
                            if (values["group"] === "common.notFound") {
                                values["group"] = $translate.instant(values["group"]);
                            }
                            if (item.modificationKey === "account.profile.historyTable.modificationNote.languageUpdated") {
                                values["fromValue"] = $translate.instant(values["fromValue"]);
                                values["toValue"] = $translate.instant(values["toValue"]);
                            }
                            //The roles coming from the server is a list of comma separated translation strings
                            //translate the list first before translating the key
                            if (values["roles"]) {
                                var translatedRoles = $translate.instant(values["roles"].split(","));
                                values["roles"] = Object.keys(translatedRoles).map(function (key) {
                                    return translatedRoles[key];
                                }).join(", ");
                            }
                        }
                        item.modificationType = $translate.instant(item.modificationKey, values);
                    });
                }
            };
            var setUserRoles = function (userRoles) {
                vm.userRoles = [];
                angular.forEach(userRoles, function (userRole) {
                    if (userRole.name === USER_ROLES.forumModerator && !frameworkService.data.tenantFeatures.forums)
                        return;
                    else if (userRole.name === USER_ROLES.organizationAdmin && !frameworkService.data.tenantFeatures.organization)
                        return;
                    else if (userRole.name === USER_ROLES.groupAdmin && !frameworkService.data.tenant.hasGroups)
                        return;
                    var role = _.find(CONST_ALLROLES, { name: userRole.name });
                    if (role)
                        vm.userRoles.push(role);
                });
            };
            vm.reloadData = function () {
                myAccountResource.get(function (result) {
                    setUserRoles(result.roles);
                    //angular.merge(vm.profileRecord, result);
                    //vm.profileRecord = angular.copy(vm.profileRecord);
                    vm.profileRecord = result;
                    if (vm.historyOpen)
                        loadNotes();
                    else
                        vm.profileRecord.userModificationNotes = [];
                    vm.accountDetailsLoaded = true;
                    vm.personalInformationEnabled = vm.profileRecord.selfRegistrationEnabledFields.gender ||
                        vm.profileRecord.selfRegistrationEnabledFields.birthdate ||
                        vm.profileRecord.selfRegistrationEnabledFields.phone1 ||
                        vm.profileRecord.selfRegistrationEnabledFields.phone2 ||
                        vm.profileRecord.selfRegistrationEnabledFields.fax ||
                        vm.profileRecord.selfRegistrationEnabledFields.organizationName ||
                        vm.profileRecord.customQuestions.length > 0;
                    if (vm.profileRecord.selfRegistrationEnabledFields.billingInformation &&
                        vm.profileRecord.selfRegistrationEnabledFields.billingInformation.value &&
                        vm.profileRecord.selfRegistrationEnabledFields.billingInformation.value.threeLetterISOCountryCode) {
                        globalizationService.load(vm.profileRecord.selfRegistrationEnabledFields.billingInformation.value.threeLetterISOCountryCode, function (result) {
                            vm.stateProvinceLabel = result.stateProvinceLabel;
                            vm.postalZipLabel = result.postalZipLabel;
                            vm.phoneNumberMask = result.phoneNumberMask;
                            vm.postalZipMask = result.postalZipMask;
                            vm.faxNumberMask = result.faxNumberMask;
                        });
                    }
                    else {
                        vm.phoneNumberMask = null;
                        vm.faxNumberMask = null;
                    }
                }, function (error) {
                    messageService.error(error);
                });
            };
            vm.reloadData();
            vm.toggleHistory = function () {
                vm.historyOpen = !vm.historyOpen;
                if (vm.historyOpen && vm.profileRecord.userModificationNotes.length === 0)
                    loadNotes();
            };
            var loadNotes = function () {
                myAccountResource.getModificationNotes(function (result) {
                    vm.profileRecord.userModificationNotes = result;
                    vm.processModificationNotes();
                });
            };
            //EXAMPLE - Modal loading directive passing record
            vm.openAboutMeModal = function (profileRecord) {
                var modalInstance = $uibModal.open({
                    template: "<about-me profile-record=\"vm.profileRecord\" modal-instance=\"vm.modalInstance\"></about-me>",
                    backdrop: "static",
                    controller: function () {
                        this.profileRecord = profileRecord;
                        this.modalInstance = modalInstance;
                    },
                    controllerAs: "vm"
                });
                modalInstance.result.then(function (result) {
                    var currentLanguage = vm.profileRecord.localizationId;
                    vm.profileRecord = result;
                    vm.reloadData();
                    $rootScope.$broadcast("updateCurrentUserData", {
                        firstName: vm.profileRecord.firstName,
                        lastName: vm.profileRecord.lastName
                    });
                    if (currentLanguage !== vm.profileRecord.localizationId) {
                        vm.setLocale(vm.profileRecord.localizationId);
                    }
                }).catch(angular.noop);
            };
            vm.openMyPreferences = function () {
                var modalInstance = $uibModal.open({
                    templateUrl: "app/account/edit/myPreferencesView.html",
                    controller: "MyPreferencesCtrl as vm",
                    scope: $scope,
                    backdrop: "static",
                    resolve: {
                        profileRecord: function () {
                            return angular.copy(vm.profileRecord);
                        }
                    }
                });
                modalInstance.result.then(function (result) {
                    var currentLanguage = vm.profileRecord.localizationId;
                    if (currentLanguage !== result.localizationId) {
                        vm.setLocale(result.localizationId);
                    }
                    vm.reloadData();
                }).catch(angular.noop);
            };
            vm.setLocale = function (localizationId) {
                var localization = _.find(vm.enabledLocalizations, { id: localizationId });
                frameworkService.setLocale(localization.languageCulture, localizationId, localization.name, function () {
                    $state.reload();
                });
                $rootScope.$broadcast("setAngularLocale", localization);
            };
            //------------Profile History Table -----------------------
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
                .withOption("processing", true)
                .withOption("responsive", { details: { type: "column" } })
                .withOption("order", [0, "desc"])
                .withPaginationType("full_numbers")
                .withDOM("lftip")
                .withBootstrap();
            vm.dtColumnDefs = [
                DTColumnDefBuilder.newColumnDef([0]).withOption("type", "date")
            ];
            vm.openEditImageModal = function (profileRecord) {
                $uibModal.open({
                    templateUrl: "app/account/edit/profilePictureView.html",
                    controller: "ProfilePictureCtrl as vm",
                    scope: $scope,
                    backdrop: "static",
                    resolve: {
                        profileRecord: function () {
                            return angular.copy(profileRecord);
                        }
                    }
                }).result.catch(angular.noop);
                //modalInstance.result.then(angular.noop).catch(angular.noop);
            };
            //-----------------------billing info modal
            vm.openUpdateAddressInfoModal = function () {
                var modalInstance = $uibModal.open({
                    templateUrl: "app/accounts/edit/billingInformationView.html",
                    controller: "BillingInformationCtrl as vm",
                    scope: $scope,
                    backdrop: "static",
                    resolve: {
                        profileRecord: function () {
                            return angular.copy(vm.profileRecord);
                        }
                    }
                });
                modalInstance.result.then(function (labels) {
                    vm.postalZipLabel = labels.postalCodeLabel;
                    vm.stateProvinceLabel = labels.provinceLable;
                    vm.reloadData();
                }).catch(angular.noop);
            };
            //-----------------------Personal info modal
            vm.openUpdatePersonalInfoModal = function () {
                var modalInstance = $uibModal.open({
                    templateUrl: "app/accounts/edit/personalInformationView.html",
                    controller: "PersonalInformationCtrl as vm",
                    scope: $scope,
                    backdrop: "static",
                    resolve: {
                        profileRecord: function () {
                            var profile = angular.copy(vm.profileRecord);
                            profile.phoneMask = vm.phoneNumberMask;
                            profile.faxMask = vm.faxNumberMask;
                            return profile;
                        }
                    }
                });
                modalInstance.result.then(function () {
                    vm.reloadData();
                }).catch(angular.noop);
            };
            //------------Custom Questions -----------------------
            vm.getAnswerForQuestion = function (question) {
                var answerId = parseInt(question.answer);
                var answer = _.find(question.answers, { id: answerId });
                if (!answer)
                    return "";
                return answer.name;
            };
            vm.getAnswer = function (question) {
                if (question.typeId === 1)
                    return vm.getAnswerForQuestion(question);
                if (question.typeId === 2 && question.answer) {
                    return moment.utc(question.answer).format("LL");
                }
                return question.answer;
            };
            //------------Link Accounts -------------------------
            function loadExternalProviders() {
                accountsResource.getExternalLogins({ returnUrl: "/account/connect-external-login", generateState: true, authenticate: false }, function (result) {
                    vm.externalProviders = result;
                }, function (error) {
                    messageService.error(error);
                });
            }
            loadExternalProviders();
            vm.openExternalProvider = function (provider) {
                vm.connectingAccount = [];
                vm.connectingAccount[provider.name] = true;
                location.href = provider.url;
            };
            vm.isExternalLoginLinked = function (name) {
                return _.includes(_.pluck(vm.profileRecord.externalLogins, "key"), name);
            };
            vm.removeLogin = function (name) {
                vm.connectingAccount = [];
                vm.connectingAccount[name] = true;
                var provider = _.find(vm.profileRecord.externalLogins, { key: name });
                if (!provider)
                    return;
                accountsResource.removeExternalLogin({ loginProvider: provider.key, providerKey: provider.value }, function () {
                    vm.profileRecord.externalLogins = _.without(vm.profileRecord.externalLogins, provider);
                    messageService.success("common.changesSaved");
                    delete vm.connectingAccount;
                }, function (error) {
                    delete vm.connectingAccount;
                    messageService.error(error);
                });
            };
        }
    });
}());
